import { RedoModal } from "@redotech/arbiter/modal/redo-modal";
import { ProvisionType } from "@redotech/congo-enums/provision-type";
import { useTranslation } from "@redotech/redo-i18n";
import {
  isReturnStatusDisplayedRejected,
  ReturnStatus,
} from "@redotech/redo-return-core-common/return-status";
import { memo } from "react";

export function isReturnCancellable({
  status,
  provision,
}: {
  status: string | undefined;
  provision: ProvisionType | null | undefined;
}): boolean {
  if (status === undefined) {
    return false;
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  if (isReturnStatusDisplayedRejected[status as ReturnStatus]) {
    return false;
  }
  if (status === ReturnStatus.COMPLETE) {
    return false;
  }
  if (status === ReturnStatus.NEEDS_REVIEW) {
    return false;
  }
  if (provision === ProvisionType.Instant) {
    return false;
  }
  return true;
}

export const CancelReturnModal = memo(function CancelReturnModal({
  onConfirm,
  onClose,
}: {
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  return (
    <RedoModal
      onModalCloseRequested={onClose}
      primaryButton={{
        text: t("Cancel return"),
        onClick: onConfirm,
        theme: "destructive",
      }}
      secondaryButton={{ text: t("Keep return"), onClick: onClose }}
      subtitle={t(
        "You will no longer be able to use your return label. If you change your mind, you can always start a new return.",
      )}
      title={t("Cancel this return?")}
    />
  );
});
